import { render, staticRenderFns } from "./NGO.vue?vue&type=template&id=0928d5a2&scoped=true&"
import script from "./NGO.vue?vue&type=script&lang=js&"
export * from "./NGO.vue?vue&type=script&lang=js&"
import style0 from "./NGO.vue?vue&type=style&index=0&id=0928d5a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928d5a2",
  null
  
)

export default component.exports